module.exports = __webpack_public_path__ + "img/logocolor.49e3d3df.png";